import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { env } from "../../../env";
import axiosInstance from "../../globalInspector/axiosInstance";
import CommonToast from "../../../components/_utils/CommonToast";
import ICONS from "../../../assets/Icons";
const baseUrl = env.REACT_APP_BASE_URL;

export const scheduleInternalTxnCreate = createAsyncThunk(
  "scheduleInternalTxnCreate",
  async (values, { rejectWithValue }) => {
    const {
      amount,
      internal_account_id,
      owner_account_id,
      category,
      additional_data,
      payment_method,
      frequency,
      confidential_transaction,
      occurrences,
      type_of_transactions,
      transaction_start_date,
      transaction_end_date,
      slot,
      transaction_day,
      transaction_month,
      scheduled_name,
    } = values?.internalData;

    const requestBody = {
      amount,
      internal_account_id,
      owner_account_id,
      category,
      additional_data,
      payment_method,
      frequency,
      confidential_transaction,
      occurrences,
      type_of_transactions,
      transaction_start_date,
      transaction_end_date,
      slot,
      transaction_day,
      transaction_month,
      scheduled_name,
    };
    const config = {
      headers: {
        "Content-Type": "application/json",
        "X-Api-Key": sessionStorage.getItem("q2p_token"),
      },
    };

    try {
      if (
        values?.services?.includes("Admin") ||
        values?.services?.includes("ICScheduledTxn")
      ) {
        const response = await axiosInstance.post(
          `${baseUrl}/transactions/scheduled_internal`,
          requestBody,
          config,
        );
        values?.navigate(
          `/internal_transaction_dashboard/create_schedule_transaction/success/${response?.data?.transaction[0]?.txn_id}`,
        );
        return response?.data;
      } else {
        values?.navigate("/feature_not_assigned");
        return rejectWithValue({ error: "Feature not assigned." });
      }
    } catch (error) {
      if (error?.response) {
        values?.navigate(
          "/internal_transaction_dashboard/create_schedule_transaction/failed",
        );
        return rejectWithValue(error?.response?.data);
      } else {
        return rejectWithValue(error);
      }
    }
  },
);

export const scheduleInternalTxnOccurrences = createAsyncThunk(
  "scheduleInternalTxnOccurrences",
  async (values, { rejectWithValue }) => {
    const { frequency, transaction_start_date, transaction_end_date } = values;

    try {
      if (
        values?.services?.includes("Admin") ||
        values?.services?.includes("IOScheduledTxn")
      ) {
        const response = await axiosInstance.get(
          `${baseUrl}/transactions/scheduled_internal/calculate_occurrences`,
          {
            headers: {
              "Content-Type": "application/json",
              "X-Api-Key": sessionStorage.getItem("q2p_token"),
            },
            params: {
              frequency: frequency,
              transaction_start_date: transaction_start_date,
              transaction_end_date: transaction_end_date,
            },
          },
        );
        return response?.data;
      } else {
        values?.navigate("/feature_not_assigned", {
          state: { unavailableService: "IOScheduledTxn" },
        });
      }
    } catch (error) {
      if (error?.response) {
        const responseData = error?.response?.data;
        const errorMessage =
          responseData?.errors?.category?.[0] ||
          responseData?.errors?.additional_data?.[0] ||
          responseData?.errors?.base?.[0] ||
          responseData?.errors ||
          "An unexpected error occurred";
        CommonToast({
          text: errorMessage,
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
        return rejectWithValue(error?.response?.status);
      } else {
        CommonToast({
          text: "Network error. Please try again.",
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
        return rejectWithValue(error);
      }
    }
  },
);

export const scheduleInternalTxnView = createAsyncThunk(
  "scheduleInternalTxnView",
  async (values) => {
    const {
      page_no,
      page_item_count,
      amount,
      lifecycle_status,
      frequency,
      occurrences,
      slot,
      transaction_day,
      transaction_month,
      transaction_start_date,
      transaction_end_date,
      internal_transaction_ids,
      payment_method,
      category,
      internal_account_id,
      owner_account_id,
      confidential_transaction,
      start_date,
      end_date,
      category_value,
      category_name,
      search_string,
      distribution_lifecycle_status,
      scheduled_name,
    } = values;
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/transactions/scheduled_internal`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          params: {
            page_no: page_no,
            page_size: page_item_count,
            amount: amount,
            lifecycle_status: lifecycle_status,
            frequency: frequency,
            occurrences: occurrences,
            slot: slot,
            transaction_day: transaction_day,
            transaction_month: transaction_month,
            // transaction_start_date,
            transaction_start_date: transaction_start_date,
            transaction_end_date: transaction_end_date,
            internal_transaction_ids: internal_transaction_ids,
            payment_method: payment_method,
            category: category,

            internal_account_id: internal_account_id,
            owner_account_id: owner_account_id,
            confidential_transaction:
              confidential_transaction === "Show only confidential"
                ? "Y"
                : confidential_transaction === "Hide confidential"
                  ? "N"
                  : undefined,
            start_date,
            end_date,
            search_string: search_string,
            category_name: category_name,
            category_value: category_value,
            distribution_lifecycle_status: distribution_lifecycle_status,
            scheduled_name: scheduled_name,
          },
        },
      );
      return response?.data;
    } catch (error) {
      CommonToast({
        text: error?.response?.data?.error,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      throw error;
    }
  },
);

export const schedulesInternalTxnDetails = createAsyncThunk(
  "schedulesInternalTxnDetails",
  async (values, { rejectWithValue }) => {
    const id = values?.id;
    try {
      if (
        values?.services?.includes("Admin") ||
        values?.services?.includes("IVScheduledTxn")
      ) {
        const response = await axiosInstance.get(
          `${baseUrl}/transactions/scheduled_internal/${id}`,
          {
            headers: {
              "Content-Type": "application/json",
              "X-Api-Key": sessionStorage.getItem("q2p_token"),
            },
          },
        );
        return response.data;
      } else {
        values?.navigate("/feature_not_assigned");
      }
    } catch (error) {
      console.error("error", error);
      return rejectWithValue(error?.response?.data || error?.message);
    }
  },
);

export const schedulesInternalTxnApproval = createAsyncThunk(
  "schedulesInternalTxnApproval",
  async (values, { rejectWithValue }) => {
    try {
      const data = {
        txn_id: Array.isArray(values?.id) ? values?.id : [values?.id],
      };

      if (
        values?.services?.includes("Admin") ||
        values?.services?.includes("IAScheduledTxn")
      ) {
        const response = await axiosInstance.put(
          `${baseUrl}/transactions/scheduled_internal/approve`,
          data,
          {
            headers: {
              "Content-Type": "application/json",
              "X-Api-Key": sessionStorage.getItem("q2p_token") || "",
            },
          },
        );

        return response.data;
      }
    } catch (error) {
      console.error("error", error);
      return rejectWithValue(error.response?.data);
    }
  },
);

export const schedulesInternalTxnReject = createAsyncThunk(
  "schedulesInternalTxnReject",
  async (values, { rejectWithValue }) => {
    const data = {
      txn_id:
        values?.type === "multiReject"
          ? values?.id
          : values?.type === "scheduleInternalTxn"
            ? values?.id
            : [values?.id],
      reason: values?.reason,
    };

    try {
      if (
        values?.services?.includes("Admin") ||
        values?.services?.includes("IAScheduledTxn")
      ) {
        const response = await axiosInstance.put(
          `${baseUrl}/transactions/scheduled_internal/reject`,
          data,
          {
            headers: {
              "Content-Type": "application/json",
              "X-Api-Key": sessionStorage.getItem("q2p_token"),
            },
          },
        );

        return response.data;
      } else {
        values?.navigate("/feature_not_assigned");
      }
    } catch (error) {
      return rejectWithValue(error.response?.data ?? "An error occurred");
    }
  },
);

export const schedulesInternalTxnDelete = createAsyncThunk(
  "schedulesInternalTxnDelete",
  async (values, { rejectWithValue }) => {
    try {
      if (
        values?.services?.includes("Admin") ||
        values?.services?.includes("IAScheduledTxn")
      ) {
        const response = await axiosInstance.delete(
          `${baseUrl}/transactions/scheduled_internal/delete`,
          {
            headers: {
              "Content-Type": "application/json",
              "X-Api-Key": sessionStorage.getItem("q2p_token"),
            },
            data: {
              txn_id: [values?.id],
            },
          },
        );
        return response.data;
      } else {
        values?.navigate("/feature_not_assigned");
      }
    } catch (error) {
      const discardError = error?.response?.data?.errors?.base?.[0]?.errors;
      const message = discardError?.join(", ") || error.message;
      setTimeout(() => {
        CommonToast({
          text: message,
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }, 1500);
    }
  },
);

const scheduleInternalTxnSlice = createSlice({
  name: "scheduleInternalTxnSlice",
  initialState: {
    schedulesInternalTxnCreateData: null,
    schedulesInternalTxnCreateLoading: null,
    schedulesInternalTxnCreateError: null,

    schedulesInternalTxnOccurrencesData: null,
    schedulesInternalTxnOccurrencesLoading: null,
    schedulesInternalTxnOccurrencesError: null,

    schedulesInternalTxnViewAllData: null,
    schedulesInternalTxnViewAllLoading: null,
    schedulesInternalTxnViewAllError: null,

    schedulesInternalTxnDetailData: null,
    schedulesInternalTxnDetailLoading: null,
    schedulesInternalTxnDetailError: null,

    schedulesInternalTxnApprovalData: null,
    schedulesInternalTxnApprovalLoading: null,
    schedulesInternalTxnApprovalError: null,

    schedulesInternalTxnRejectData: null,
    schedulesInternalTxnRejectLoading: null,
    schedulesInternalTxnRejectError: null,

    schedulesInternalTxnDeleteData: null,
    schedulesInternalTxnDeleteLoading: null,
    schedulesInternalTxnDeleteError: null,

    storedPage: 1,
  },

  reducers: {
    resetpage: (state) => {
      state.storedPage = 1;
    },
    setStoredPage: (state, action) => {
      state.storedPage = action.payload;
    },
    clearInternalSchedulesTxnErrors: (state) => {
      state.schedulesInternalTxnApprovalError = null;
      state.schedulesInternalTxnRejectError = null;
    },
    updateScheduleDetailData: (state, action) => {
      state.schedulesInternalTxnDetailData = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(scheduleInternalTxnCreate.pending, (state) => {
      state.schedulesInternalTxnCreateLoading = true;
    });
    builder.addCase(scheduleInternalTxnCreate.fulfilled, (state, action) => {
      state.schedulesInternalTxnCreateLoading = false;
      state.schedulesInternalTxnCreateData = action?.payload;
    });
    builder.addCase(scheduleInternalTxnCreate.rejected, (state, action) => {
      state.schedulesInternalTxnCreateLoading = false;
      state.schedulesInternalTxnCreateData = false;
      state.schedulesInternalTxnCreateError = action?.payload;
    });
    builder.addCase(scheduleInternalTxnOccurrences.pending, (state) => {
      state.schedulesInternalTxnOccurrencesLoading = true;
    });
    builder.addCase(
      scheduleInternalTxnOccurrences.fulfilled,
      (state, action) => {
        state.schedulesInternalTxnOccurrencesLoading = false;
        state.schedulesInternalTxnOccurrencesData = action?.payload;
      },
    );
    builder.addCase(
      scheduleInternalTxnOccurrences.rejected,
      (state, action) => {
        state.schedulesInternalTxnOccurrencesLoading = false;
        state.schedulesInternalTxnOccurrencesData = false;
        state.schedulesInternalTxnOccurrencesError = action?.payload;
      },
    );
    builder.addCase(scheduleInternalTxnView.pending, (state) => {
      state.schedulesInternalTxnViewAllLoading = true;
    });
    builder.addCase(scheduleInternalTxnView.fulfilled, (state, action) => {
      state.schedulesInternalTxnViewAllLoading = false;
      state.schedulesInternalTxnViewAllData = action?.payload;
    });
    builder.addCase(scheduleInternalTxnView.rejected, (state, action) => {
      state.schedulesInternalTxnViewAllLoading = false;
      state.schedulesInternalTxnViewAllData = false;
      state.schedulesInternalTxnViewAllError = action?.payload;
    });
    builder.addCase(schedulesInternalTxnDetails.pending, (state) => {
      state.schedulesInternalTxnDetailLoading = true;
    });
    builder.addCase(schedulesInternalTxnDetails.fulfilled, (state, action) => {
      state.schedulesInternalTxnDetailLoading = false;
      state.schedulesInternalTxnDetailData = action?.payload;
    });
    builder.addCase(schedulesInternalTxnDetails.rejected, (state, action) => {
      state.schedulesInternalTxnDetailData = false;
      state.schedulesInternalTxnDetailLoading = false;
      state.schedulesInternalTxnDetailError = action?.payload;
    });

    builder.addCase(schedulesInternalTxnApproval.pending, (state) => {
      state.schedulesInternalTxnApprovalLoading = true;
    });
    builder.addCase(schedulesInternalTxnApproval.fulfilled, (state, action) => {
      state.schedulesInternalTxnApprovalLoading = false;
      state.schedulesInternalTxnApprovalData = action?.payload;
    });
    builder.addCase(schedulesInternalTxnApproval.rejected, (state, action) => {
      sessionStorage.setItem(
        "ScheduleInternalMultiDataError",
        JSON.stringify(action.payload?.errors?.base),
      );
      state.schedulesInternalTxnApprovalData = false;
      state.schedulesInternalTxnApprovalLoading = false;
      state.schedulesInternalTxnApprovalError = action?.payload;
    });
    builder.addCase(schedulesInternalTxnReject.pending, (state) => {
      state.schedulesInternalTxnRejectLoading = true;
    });
    builder.addCase(schedulesInternalTxnReject.fulfilled, (state, action) => {
      state.schedulesInternalTxnRejectLoading = false;
      state.schedulesInternalTxnRejectData = action?.payload;
    });
    builder.addCase(schedulesInternalTxnReject.rejected, (state, action) => {
      sessionStorage.setItem(
        "ScheduleInternalMultiDataError",
        JSON.stringify(action.payload?.errors?.base),
      );
      state.schedulesInternalTxnRejectLoading = false;
      state.schedulesInternalTxnRejectError = action?.payload;
      state.schedulesInternalTxnRejectData = false;
    });
    builder.addCase(schedulesInternalTxnDelete.pending, (state) => {
      state.schedulesInternalTxnDeleteLoading = true;
    });
    builder.addCase(schedulesInternalTxnDelete.fulfilled, (state, action) => {
      state.schedulesInternalTxnDeleteLoading = false;
      state.schedulesInternalTxnDeleteData = action?.payload;
    });
    builder.addCase(schedulesInternalTxnDelete.rejected, (state, action) => {
      state.schedulesInternalTxnDeleteLoading = false;
      state.schedulesInternalTxnDeleteError = action?.payload;
      state.schedulesInternalTxnDeleteData = false;
    });
  },
});

export const {
  resetpage,
  setStoredPage,
  updateScheduleDetailData,
  clearInternalSchedulesTxnErrors,
} = scheduleInternalTxnSlice.actions;
export default scheduleInternalTxnSlice.reducer;
